module.exports = __webpack_public_path__ + "static/media/season-loser.fcb9924d.png";